<style lang="scss" scoped>
.Index-base-warp {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background: #dedede;
  $headerHeight: 47px;
  $mainHeight: 360px;
  .header {
    width: 100%;
    height: $headerHeight;
    background: #e0eaf6;
    .content {
      display: flex;
      .logo {
        img {
          padding-top: 5px;
          width: 100%;
          height: 90%;
        }
      }
      .nav-warp {
        display: flex;
        margin-left: auto;
        .nav-item {
          line-height: $headerHeight;
          padding: 0 15px;
          cursor: pointer;
          &:hover,
          &.act {
            border-bottom: 4px solid #016cff;
            transition: 0.2s;
          }
        }
      }
    }
  }
  .main-warp {
    width: 100%;
    height: $mainHeight;
    background: #ebeffd;
    position: relative;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
    }
    .content {
      position: relative;
      .donwload-box {
        position: absolute;
        left: 36px;
        top: 210px;
        width: 150px;
        border: 0;
        cursor: pointer;
        .donwload-img-warp {
          width: 100%;
          height: 45px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &:hover {
          .donwlad-item-warp .donwlad-item {
            display: block;
          }
        }
        .donwlad-item-warp {
          position: absolute;
          z-index: 999;
          width: 100%;
          padding-top: 5px;

          .donwlad-item {
            width: 100%;
            padding: 5px;
            background: #fff;
            border: 1px solid #dedede;
            border-radius: 5px;
            text-align: center;
            display: none;
            margin-bottom: 5px;
            .title {
              font-size: 14px;
              font-weight: 600;
              padding-bottom: 2px;
            }
            .tip {
              color: #a9a9aa;
            }
          }
        }
      }
    }
  }
  .body {
    background: #fff;
    width: 100%;
    padding: 24px 0;
  }
  .slogan-box {
    text-align: center;
    width: 100%;
    height: 420px;
    background: #28328e;
    padding-top: 86px;
    img {
      width: 1002px;
      height: 190px;
    }
  }
  .footer {
    background: #0a1633;
    height: 193px;
    overflow: hidden;

    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: rgba(255, 255, 255, 0.4);
    .content {
      display: flex;
      flex-direction: column;
      .top {
        font-weight: 600;
        padding-left: 15px;
        padding-top: 15px;
        flex: 1;
      }
      .bottom {
        padding-left: 15px;
        height: 76px;
        line-height: 85px;
      }
    }
  }
}
.content {
  margin: 0 auto;
  width: 1024px !important;
}
</style>

<template>
  <div class="Index-base-warp">
    <div class="header">
      <div class="content">
        <div class="logo">
          <img src="@/assets/logo.png" />
        </div>
        <div class="nav-warp">
          <div
            @click="actdNav(nav)"
            class="nav-item"
            :class="{ act: actNav.label === nav.label }"
            v-for="nav in navs"
            :key="nav.label"
          >
            {{ nav.label }}
          </div>
          <div v-if="!userInfo.userId" @click="login" class="nav-item">
            登陆
          </div>
          <div v-if="userInfo.userId" class="nav-item" @click="toIndex">
            <a>控制台</a>
          </div>
          <div class="nav-item" v-if="userInfo.userId">
            <span style="padding-right: 5px"
              >欢迎您 {{ userInfo.nickname }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="main-warp">
      <img :src="actNav.img" />
      <div class="content">
        <div class="donwload-box">
          <div class="donwload-img-warp">
            <a href="https://wwpd.lanzouw.com/b04e99cgf" target="_blank">
              <img src="@/assets/download-btn.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="content">
        <component :is="actNav.component" @on-free-test="freeTest"></component>
      </div>
    </div>

    <div class="footer">
      <div class="content">
        <div class="top">
          <div>
            <span style="padding-right: 15px">Copyright © 2012-2023 </span>
            <span>UCloud</span>
          </div>
          <div style="padding-top: 15px">成都云启点网络科技有限公司</div>
          <div style="padding-top: 15px">E-mail: yifanyi@traneasy.com.cn</div>
        </div>
        <div class="bottom">
          <span v-if="chromeCheck">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener"
              >蜀ICP备2024115121号</a
            >
          </span>
        </div>
      </div>
    </div>

    <!-- <AffixCustomerService @on-free-test="freeTest" :innerHeight="innerHeight" /> -->
    <LoginDrawer ref="LoginDrawerRef" @on-login-success="loginSuccess" />
  </div>
</template>

<script>
import userService from "@/service/user";
import dataService from "@/service/data";

export default {
  name: "Index",
  data() {
    let origin = window.location.origin;
    let chromeCheck = origin.includes("www.traneasy.vip");
    let navs = [
      {
        label: "软件下载",
        img: require("@/assets/bg/home.png"),
        component: "Home",
      },
    ];
    let actNav = navs[0];
    return {
      chromeCheck,
      isFreeTest: false,
      userInfo: {},
      downloadData: [],
      innerHeight: window.innerHeight,
      navs,
      actNav,
    };
  },
  mounted() {
    let { act } = this.$route.query;
    if (act) {
      for (var i in this.navs) {
        let nav = this.navs[i];
        if (nav.label === act) {
          this.actNav = nav;
          break;
        }
      }
    }
    window.onresize = () => {
      this.innerHeight = window.innerHeight;
    };
    this.init();
  },

  methods: {
    async init() {
      let data = await dataService.get("SOFT_REPLAY_DOWNLOAD_CONFIG");
      this.downloadData = JSON.parse(data.valued);
      if (!sessionStorage.getItem("sk")) {
        return;
      }
      let userInfo = await userService.get();
      if (userInfo) {
        this.userInfo = userInfo;
      }
    },
    actdNav(nav) {
      this.actNav = nav;
    },
    login() {
      this.$refs.LoginDrawerRef.open(1);
    },
    async loginSuccess() {
      this.userInfo = await userService.get();
      if (this.isFreeTest) {
        this.freeTest();
      }
    },
    toIndex() {
      this.$router.push({ name: "UserCenter" });
    },
    freeTest() {
      this.isFreeTest = true;
      if (!this.userInfo.userId) {
        this.login();
        return;
      }
      if (this.userInfo.memberGroupId === 1) {
        this.$router.push({ name: "UserCenterChangeTranslateTest" });
      } else {
        this.$router.push({ name: "UserCenterRecharge" });
      }
    },
  },
};
</script>

